import { set } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '@feathr/components';

import type { IImportMappingCellProps } from './ImportMappingTable.utils';

/** The mapping row's file column, picked from the file's column names. */
function ImportMappingColumnCell({
  column,
  importer,
  disabled,
}: Readonly<IImportMappingCellProps>): JSX.Element {
  const { t } = useTranslation();
  const options = (importer.get('column_names') as string[]).map((name) => ({
    id: name,
    name,
  }));

  function handleSelectColumn(option: { id: string; name: string }): void {
    set(column, 'column_name', option.id);
    importer.setAttributeDirty('column_mappers');
  }

  return (
    <Select
      aria-label={t('Column in your file')}
      disabled={disabled}
      // Table cells clip overflow, so the menu renders on the body.
      menuPortalTarget={document.body}
      name={'column-name'}
      onSelectSingle={handleSelectColumn}
      options={options}
      value={options.find((option) => option.id === column.column_name)}
    />
  );
}

export default observer(ImportMappingColumnCell);
